<template>
  <button
    class="btn-like"
    type="button"
    @click="toggle"
  >
    <span class="btn-like__icon">
      <i class="material-icons">
        {{isRecommend ? 'favorite' : 'favorite_border'}}
      </i>
    </span>
    <span class="btn-like__label">좋아요</span>
    <span class="btn-like__count">{{row.recommends}}</span>
  </button>
</template>

<script>
export default {
  props: {
    row: { type: Object, required: true },
    type: { type: String, required: true }
  },
  computed: {
    isRecommend () {
      return this.row.hasOwnProperty('has-recommends') && this.row['has-recommends'].length > 0
    }
  },
  methods: {
    async toggle () {
      const uri = this.type === 'comment'
        ? `/api/boards/${this.row.boardId}/seqs/${this.row.boardSeq}/comments/${this.row.seq}/recommend`
        : `/api/boards/${this.row.boardId}/seqs/${this.row.seq}/recommend`

      try {
        if (!this.isRecommend) {
          await this.$http.post(uri)
        } else {
          await this.$http.delete(uri)
        }
        this.$emit('refresh')
      } catch (ex) { }
    }
  }
}
</script>
